import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import { ChevronDoubleLeft, ChevronLeft, ChevronRight } from "mdi-material-ui";
import { useKey } from "react-use";
const getStartNode = (node) => {
    let current = node;
    while (current?.prev) {
        current = current.prev;
    }
    return current;
};
const handleStart = (setNode, node) => () => {
    const start = getStartNode(node);
    if (start && start !== node) {
        setNode(start);
    }
};
const handlePrev = (setNode, node) => () => {
    if (node?.prev) {
        setNode(node.prev);
    }
};
const handleNext = (setNode, node) => () => {
    if (node?.next[0]) {
        setNode(node.next[0]);
    }
};
export const useKeyboardJumps = (setNode, node, disabled) => {
    useKey("ArrowLeft", handlePrev(setNode, disabled ? undefined : node), {}, [
        node,
    ]);
    useKey("ArrowRight", handleNext(setNode, disabled ? undefined : node), {}, [
        node,
    ]);
};
export const useJumps = (setNode, node) => {
    return {
        startProps: {
            onClick: handleStart(setNode, node),
            disabled: !node?.prev,
        },
        prevProps: {
            onClick: handlePrev(setNode, node),
            disabled: !node?.prev,
        },
        nextProps: {
            onClick: handleNext(setNode, node),
            disabled: !node?.next[0],
        },
    };
};
export const Jumps = ({ startProps, prevProps, nextProps, }) => (_jsxs(_Fragment, { children: [_jsx(IconButton, { ...startProps, children: _jsx(ChevronDoubleLeft, {}) }), _jsx(IconButton, { ...prevProps, children: _jsx(ChevronLeft, {}) }), _jsx(IconButton, { ...nextProps, children: _jsx(ChevronRight, {}) })] }));
//# sourceMappingURL=Jumps.js.map